import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import type { Resolver } from 'react-hook-form';

export function createAddAccountValidator() {
  const schema = z.object({
    adAccountId: z.string().min(1, 'Can\'t be empty').default(''),
    name: z.string().min(1, 'Can\'t be empty').default(''),
    platform: z.string().min(1, 'Can\'t be empty').default('WEB'),
    app: z
      .string()
      .min(1, 'Can\'t be empty')
      .default(''),
    isActive: z.boolean().default(false),
    ciUpload: z.boolean().default(false),
    blacklistChecks: z.boolean().default(false),
  });

  return {
    schema,
    resolver: zodResolver(schema) as Resolver<z.infer<typeof schema>>,
  };
}
